import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TypographyTypes from './TypographyTypes';

const withTypography = (WrappedComponent, typographyProps = {}) => {
  if (TypographyTypes.indexOf(WrappedComponent) === -1) {
    return null;
  }

  class WrappedComponentWithTypography extends React.PureComponent {
    render() {
      const {
        bold,
        className,
        italic,
        variation,
        ...rest
      } = this.props;

      const classes = classnames(
        typographyProps.className,
        className,
        {
          [`${typographyProps.className}-${variation}`]: variation,
          'ds-font-bold': bold,
          'ds-font-italic': italic,
        },
      );

      return (
        <WrappedComponent className={classes} {...rest} />
      );
    }
  }

  WrappedComponentWithTypography.defaultProps = {
    bold: false,
    className: '',
    italic: false,
    variation: '',
  };
  WrappedComponentWithTypography.propTypes = {
    bold: PropTypes.bool,
    className: PropTypes.string,
    variation: PropTypes.string,
    italic: PropTypes.bool,
  };

  return WrappedComponentWithTypography;
};

export default withTypography;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Typography/withTypography.jsx